<template>
  <div class="search-wrap">
      <div class="search-box">
            <input type="text" placeholder="请输入剧本名称" v-model="searchKeyWord">
            <span class="search-btn" @click="searchScript"><van-icon name="search" /></span>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {Axios} from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name: 'SearchBox',
	data(){
		return{
			searchKeyWord:'',                   //搜索关键词
			date:new Date(),                   //定义事件对象
			curTime:'',                        //每次进入页面获取实时的时间
		}
	},
	methods:{
		searchScript(){
			//获取实时时间请求接口
			this.curTime=this.date.getFullYear()+'-'
			this.curTime=this.curTime+(this.date.getMonth()+1)+'-'
			this.curTime=this.curTime+(this.date.getDate())+' '
			this.curTime=this.curTime+(this.date.getHours())+':'
			this.curTime=this.curTime+(this.date.getMinutes())+':'
			this.curTime=this.curTime+(this.date.getSeconds())
			if(this.searchKeyWord==''){
				this.$swal({
						text:'请输入搜索关键词',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					})
				return false
			}else{
				Axios.get('/article/list',{params:{'search':this.searchKeyWord,'limitdate':this.curTime}})
					.then(
						response=>{
							if(response.data.code==200&&response.data.status=='success'){
								if(response.data.data.length){
									this.$router.push({name:'scriptlist',query:{kw:this.searchKeyWord}})
								}else{
									this.$swal({
										text:'未搜索到相关内容',
										showConfirmButton:false,
										width:'6rem',
										padding:'0.5rem',
										timer:1200,
										imageWidth:50,
										imageHeight:50,
										imageUrl:notifyIcon,
										timerProgressBar: true
									})
								}
							}
						}
					).catch(
						error=>{
							this.$swal({
								text:'网络错误请稍后重试',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1200,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							})
						}
					)
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search-wrap{
    width:720px;
    height:80px;
    transform:translateX(-360px) translateY(-40px);
    position:absolute;
    left:50%;
    box-shadow:0 0 10px #999;
    color:#999;
}
.search-box{
    input{
        width:596px;
        height:60px;
        border:none;
        padding:10px 12px !important;
        color:#999;
        font-size:24px;
		line-height:24px;
        border-radius:0 !important;
    }
    input::-webkit-input-placeholder{
        color: #ccc !important;
		line-height:30px;
    }
    input:-moz-placeholder{
        color: #ccc !important;
		line-height:30px;
    }
    input::-moz-placeholder{
        color: #ccc !important;
		line-height:30px;
    }
    input:-ms-input-placeholder{
        color: #ccc !important;
		line-height:30px;
    }
    .search-btn{
        display:inline-block;
        width:100px;
        height:30px;
		padding:25px 0;
        line-height:30px;
        vertical-align:top;
        color:#fff;
        background:#bf0000;
        text-align:center;
        i{
            font-size:26px !important;
        }
    }
}
</style>
